module.exports = __webpack_public_path__ + "img/flora_supplementbasic_202307.fbe6560e.jpg";